import { render, staticRenderFns } from "./PopupNotificationTemplate.vue?vue&type=template&id=5495d90a&scoped=true"
import script from "./PopupNotificationTemplate.vue?vue&type=script&lang=js"
export * from "./PopupNotificationTemplate.vue?vue&type=script&lang=js"
import style0 from "./PopupNotificationTemplate.vue?vue&type=style&index=0&id=5495d90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5495d90a",
  null
  
)

export default component.exports